export const CREDENTIAL = {
  model: 'toolAccess',
  create: 'toolAccessCreate',
  update: 'toolAccessUpdate',
  delete: 'toolAccessDelete',
  index: 'toolAccessIndex',
  view: 'toolAccessView',
  moderate: 'toolAccessModerate',
  indexAvailable: 'toolAccessIndexAvailable',
};

export const CREDENTIAL_GROUP = {
  model: 'toolGroup',
  create: 'toolGroupCreate',
  update: 'toolGroupUpdate',
  delete: 'toolGroupDelete',
  index: 'toolGroupIndex',
  view: 'toolGroupView',
  available: 'availableToolGroupIndex',
};

export const DEPARTMENT = {
  model: 'userDepartment',
  create: 'userDepartmentCreate',
  update: 'userDepartmentUpdate',
  delete: 'userDepartmentDelete',
  index: 'userDepartmentIndex',
  view: 'userDepartmentView',
};

export const POSITION = {
  model: 'userPosition',
  create: 'userPositionCreate',
  update: 'userPositionUpdate',
  delete: 'userPositionDelete',
  index: 'userPositionIndex',
  view: 'userPositionView',
};

export const USER = {
  model: 'user',
  create: 'userCreate',
  update: 'userUpdate',
  updateOwn: 'userUpdateOwn',
  delete: 'userDelete',
  index: 'userIndex',
  view: 'userView',
  invite: 'userInvite',
  updateSystemFields: 'userSystemFieldsUpdate',
  updateRole: 'userRoleFieldUpdate',
};

export const FREELANCER = {
  model: 'userContractor',
  create: 'userContractorCreate',
  update: 'userContractorUpdate',
  delete: 'userContractorDelete',
  index: 'userContractorIndex',
  view: 'userContractorView',
};

export const ROLES = {
  model: 'userRole',
  create: 'userRoleCreate',
  update: 'userRoleUpdate',
  delete: 'userRoleDelete',
  index: 'userRoleIndex',
  view: 'userRoleView',
};

export const SERVICE = {
  model: 'service',
  create: 'serviceCreate',
  update: 'serviceUpdate',
  delete: 'serviceDelete',
  index: 'serviceIndex',
  view: 'serviceView',
};

export const PROJECT = {
  model: 'project',
  create: 'projectCreate',
  update: 'projectUpdate',
  delete: 'projectDelete',
  index: 'projectIndex',
  view: 'projectView',
  mataUpdate: 'projectMetaUpdate',
  archive: 'projectArchive',
  pause: 'projectPause',
};

export const SERVICE_MAP = {
  model: 'projectServiceMap',
  create: 'serviceMapCreate',
  update: 'serviceMapUpdate',
  delete: 'serviceMapDelete',
  index: 'serviceMapIndex',
  view: 'serviceMapView',
};

export const CLIENT = {
  model: 'clientCompany',
  create: 'clientCompanyCreate',
  update: 'clientCompanyUpdate',
  delete: 'clientCompanyDelete',
  index: 'clientCompanyIndex',
  view: 'clientCompanyView',
};

export const PAGES = {
  companyStructure: 'companyStructureIndex',
  userWorkload: 'userWorkloadIndex',
};

export const TASK = {
  model: 'task',
  create: 'taskCreate',
  update: 'taskUpdate',
  updateOwn: 'taskUpdateOwn',
  metaUpdate: 'taskMetaUpdate',
  updateLeader: 'taskUpdateLeader',
  migrate: 'taskMigrate',
  migrateOwn: 'taskMigrateOwn',
  subscribe: 'taskSubscribe',
  delete: 'taskDelete',
  index: 'taskIndex',
  view: 'taskView',
};

export const TASK_LABEL = {
  model: 'taskLabel',
  create: 'taskLabelCreate',
  update: 'taskLabelUpdate',
  delete: 'taskLabelDelete',
  index: 'taskLabelIndex',
  available: 'availableTaskLabelIndex',
  view: 'taskLabelView',
};

export const TASK_STATUS = {
  model: 'taskStatus',
  create: 'taskStatusCreate',
  update: 'taskStatusUpdate',
  delete: 'taskStatusDelete',
  index: 'taskStatusIndex',
  available: 'availableTaskStatusIndex',
  view: 'taskStatusView',
};

export const TASK_LABEL_GROUP = {
  index: 'taskLabelGroupIndex',
  model: 'taskLabelGroup',
  create: 'taskLabelGroupCreate',
  update: 'taskLabelGroupUpdate',
  delete: 'taskLabelGroupDelete',
};

export const TASK_WORKFLOW = {
  model: 'taskWorkflow',
  index: 'taskWorkflowIndex',
  create: 'taskWorkflowCreate',
  update: 'taskWorkflowUpdate',
  delete: 'taskWorkflowDelete',
  available: 'availableTaskWorkflowIndex',
};

export const ARTICLE = {
  model: 'article',
  create: 'articleCreate',
  update: 'articleUpdate',
  updateOwn: 'articleUpdateOwn',
  delete: 'articleDelete',
  index: 'articleIndex',
  view: 'articleView',
};

export const ARTICLE_CATEGORY = {
  model: 'articleCategory',
  create: 'articleCategoryCreate',
  update: 'articleCategoryUpdate',
  delete: 'articleCategoryDelete',
  index: 'articleCategoryIndex',
  view: 'articleCategoryView',
};

export const ARTICLE_TAG = {
  model: 'articleTag',
  create: 'articleTagCreate',
  update: 'articleTagUpdate',
  delete: 'articleTagDelete',
  index: 'articleTagIndex',
  view: 'articleTagView',
};

export const EVENT = {
  model: 'event',
  create: 'eventCreate',
  update: 'eventUpdate',
  updateOwn: 'eventUpdateOwn',
  delete: 'eventDelete',
  index: 'eventIndex',
  view: 'eventView',
  moderate: 'eventModerate',
};

export const EVENT_TYPE = {
  model: 'eventType',
  create: 'eventTypeCreate',
  update: 'eventTypeUpdate',
  delete: 'eventTypeDelete',
  index: 'eventTypeIndex',
  view: 'eventTypeView',
  available: 'availableEventTypeIndex',
};
export const REPORT = {
  model: 'report',
  index: 'reportIndex',
};
export const COMMENT = {
  model: 'comment',
  index: 'commentIndex',
  create: 'commentCreate',
  update: 'commentUpdate',
  updateInTask: 'commentUpdateInTask',
  delete: 'commentDelete',
};
export const TASK_TIME = {
  model: 'taskTime',
  list: 'timeViewOwn',
  delete: 'timeDelete',
  update: 'timeUpdate',
  create: 'timeCreate',
  stop: 'timeStop',
  start: 'timeStart',
  init: 'timeInit',
};
export const LEGAL_ENTITY = {
  model: 'legalEntity',
  create: 'legalEntityCreate',
  update: 'legalEntityUpdate',
  delete: 'legalEntityDelete',
  index: 'legalEntityIndex',
  view: 'legalEntityView',
};
export const CLIENT_INVOICE = {
  model: 'clientInvoice',
  create: 'clientInvoiceCreate',
  update: 'clientInvoiceUpdate',
  delete: 'clientInvoiceDelete',
  index: 'clientInvoiceIndex',
  view: 'clientInvoiceView',
};
export const CLIENT_USER = {
  invite: 'clientUserInvite',
  create: 'clientUserCreate',
  update: 'clientUserUpdate',
  delete: 'clientUserDelete',
  index: 'clientUserIndex',
  view: 'clientUserView',
  updateRole: 'clientUserRoleFieldUpdate',
};
export const CHECKLIST = {
  model: 'checklist',
  view: 'checklistView',
  create: 'checklistCreate',
  update: 'checklistUpdate',
  delete: 'checklistDelete',
  check: 'checklistItemCheck',
  //For leader
  createLeader: 'checklistCreateLeader',
  updateLeader: 'checklistUpdateLeader',
  deleteLeader: 'checklistDeleteLeader',
  checkLeader: 'checklistCheckItemLeader',
};

export const USER_COMPANY = {
  update: 'userCompanyUpdate',
  view: 'userCompanyView',
};

export const SALARY_HISTORY = {
  index: 'salaryHistoryIndex',
  update: 'salaryHistoryUpdate',
  calculate: 'salaryHistoryCreate',
};

export const TASK_SCHEDULE = {
  model: 'taskSchedule',
  create: 'taskScheduleCreate',
  createOwn: 'taskScheduleCreateOwn',
  update: 'taskScheduleUpdate',
  updateOwn: 'taskScheduleUpdateOwn',
  delete: 'taskScheduleDelete',
  index: 'taskScheduleIndex',
  viewOwn: 'taskScheduleViewOwn',
  view: 'taskScheduleView',
};
